// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Formik } from 'formik';
import { stubFalse, values } from 'lodash';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import AvatarImage from '../../assets/static/mock-images/avatars/avatar_1.png';
import {
  useFindServiceProviderDetailByIdMutation,
  useGetAllServiceProviderDetailMutation,
  useSaveServiceProviderDetailMutation,
  useUpdateServiceProviderDetailMutation,
} from '../../store/api/serviceProviderApi';
import * as Yup from 'yup';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  ImageList,
  ImageListItem,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Page from '../../components/Page';
import { setServiceProvider } from '../../store/state/serviceProviderSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Loading from '../../components/Loading';
import Iconify from '../../components/Iconify';
import { dates as date } from '../../_mock/bookings';

const OffersSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  userId: Yup.string().required('User Id is required'),
  date: Yup.string().required('Date is required'),
  amount: Yup.string().required('Amount is required'),
  opening: Yup.string().required('Opening is required'),
  closing: Yup.string().required('Closing is required'),
});

const OffersSchemaEdit = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  userId: Yup.string().required('User Id is required'),
  date: Yup.string().required('Date is required'),
  amount: Yup.string().required('Amount is required'),
  opening: Yup.string().required('Opening is required'),
  closing: Yup.string().required('Closing is required'),
});

export default function AddWallet() {
  const dispatch = useAppDispatch();
  const [formValues, setFormValues] = useState({
    name: '',
    userId: '',
    date: '',
    amount: '',
    opening: '',
    closing: '',
    status: true,
  });
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const navigate = useNavigate();
  const [datesData, setDatesData] = useState(date);

  const { state } = useLocation();
  const [page, setPage] = useState(0);
  const [offset, setOffset] = useState(5);
  const [orderBy, setOrderBy] = useState('asc');
  const [columName, setColumName] = useState('id');
  const [itemData, setItemData] = useState(AvatarImage);

  // add
  //   useEffect(() => {
  //     if (saveResponse.isSuccess || updateResponse.isSuccess) {
  //       getAllServiceProviderDetail({
  //         token: token.token,
  //         payload: {
  //           page: page,
  //           offset: offset,
  //           orderBy: orderBy,
  //           columName: columName,
  //         },
  //       });
  //     }
  //   }, [saveResponse.isSuccess, updateResponse.isSuccess]);

  // update store
  //   useEffect(() => {
  //     if (getAllResponse.isSuccess) {
  //       dispatch(setServiceProvider(getAllResponse.data));
  //       navigate('/dashboard/vendor-details');
  //     }
  //   }, [getAllResponse.isSuccess]);

  // fetch details
  //   useEffect(() => {
  //     if (state.editMode) {
  //       findServiceProviderDetailById({ id: state.id, userId: state.userId, token: token.token });
  //     }
  //   }, [state.editMode]);

  // set formik initial values
  //   useEffect(() => {
  //     if (findByIdResponse.isSuccess) {
  //       setFormValues(() => {
  //         return {
  //           name: findByIdResponse.data.name,
  //           contactNumber: findByIdResponse.data.contactNumber,
  //           emailId: findByIdResponse.data.emailId,
  //           password: findByIdResponse.data.password ? findByIdResponse.data.password : '',
  //           gstNo: findByIdResponse.data.gstNo,
  //           primaryAccountNo: findByIdResponse.data.primaryAccountNo,
  //           vatNo: findByIdResponse.data.vatNo,
  //           status: true,
  //         };
  //       });
  //     }
  //   }, [findByIdResponse.isSuccess]);

  //   const saveServiceProviderDataToServer = async (values) => {
  //     await saveServiceProviderDetail({
  //       payload: {
  //         name: values.name,
  //         contactNumber: values.contactNumber,
  //         emailId: values.emailId,
  //         password: values.password,
  //         gstNo: values.gstNo,
  //         primaryAccountNo: values.primaryAccountNo,
  //         vatNo: values.vatNo,
  //         status: true,
  //       },
  //       token: token.token,
  //     });
  //   };

  //   const updateDataInServer = async (values) => {
  //     await updateServiceProviderDetail({
  //       payload: {
  //         id: state.id,
  //         userId: state.userId,
  //         name: values.name,
  //         emailId: values.emailId,
  //         contactNumber: values.contactNumber,
  //         gstNo: values.gstNo,
  //         primaryAccountNo: values.primaryAccountNo,
  //         vatNo: values.vatNo,
  //         status: true,
  //       },
  //       token: token.token,
  //     });
  //   };

  const handleAddNewOffers = (values, action) => {
    // if (state.editMode) {
    //   updateDataInServer(values);
    //   toast.success('Vendor Updated Successfully');
    // } else {
    //   saveServiceProviderDataToServer(values);
    //   toast.success('Vendor added successfully');
    // }
    // action.resetForm();
    alert('Offers added successfully');
  };

  return (
    <Page title="Add Wallet">
      <Formik
        enableReinitialize={true}
        initialValues={formValues}
        onSubmit={handleAddNewOffers}
        validationSchema={state.editMode ? OffersSchemaEdit : OffersSchema}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
          <Container
            sx={{
              paddingTop: '2rem',
              paddingBottom: '2rem',
            }}
          >
            <Typography variant="h3" marginBottom={'20px'} component="div">
              {state.editMode ? 'Update Wallet' : 'Add Wallet'}
            </Typography>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width={'100%'}>
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    User Name
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Username"
                    name={'name'}
                    value={values.name}
                    valueTo
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    User Id
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="userID..."
                    name={'userId'}
                    value={values.userId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.userId && errors.userId)}
                    helperText={touched.userId && errors.userId}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Date of Transaction
                  </Typography>
                  <Select
                    name="date"
                    id="date"
                    key={values.date}
                    value={values.date}
                    style={{
                      width: '80%',
                    }}
                    onChange={handleChange}
                    error={Boolean(touched.date && errors.date)}
                  >
                    {datesData &&
                      datesData?.map((response) => {
                        return (
                          <MenuItem key={response.id} value={response.id}>
                            <Box sx={{ width: 28, mr: 2 }}>{response.date}</Box>
                          </MenuItem>
                        );
                      })}
                  </Select>
                </Stack>
              </Box>
              <Box width="100%">
                <Stack
                  direction="column"
                  alignItems="self-start"
                  //   style={{ display: state.editMode ? 'none' : 'block' }}
                >
                  <Typography variant="h5" gutterBottom component="div">
                    Amount
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="amount..."
                    name={'amount'}
                    value={values.amount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.amount && errors.amount)}
                    helperText={touched.amount && errors.amount}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Opening Amount
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter Amount..."
                    name={'opening'}
                    value={values.opening}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.opening && errors.opening)}
                    helperText={touched.opening && errors.opening}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Offer Ends at
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter Amount..."
                    name={'closing'}
                    value={values.closing}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.closing && errors.closing)}
                    helperText={touched.closing && errors.closing}
                  />
                </Stack>
              </Box>
            </Box>
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', marginRight: '100px' }}>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  navigate('/dashboard/wallet-management');
                }}
                sx={{ marginRight: '10px' }}
                size="large"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleSubmit();
                }}
                size="large"
                type="submit"
              >
                {state.editMode ? 'Update' : 'Add'}
              </Button>
            </div>
          </Container>
        )}
      </Formik>
      {/* {saveResponse.isLoading || getAllResponse.isLoading || findByIdResponse.isLoading || updateResponse.isLoading ? (
        <Loading />
      ) : null} */}
    </Page>
  );
}
